module.exports = __webpack_public_path__ + "CatYay-3122d362b3e232776767462653b7e131.svg";